<template>
  <Content>
    <Anchor class="video-links-anchor" :offset-top="110" :bounds="40" :show-ink="true">
      <AnchorLink :title="$t('manage.resources.available')" href="#files" />
      <AnchorLink title="Black Box Building Example" href="#1" />
      <AnchorLink title="How to fold the white boxes" href="#2" />
    </Anchor>
      <Card style="text-align: center;" :dis-hover="true" name="files" id="files">
        <template slot="title">{{$t('manage.resources.available')}}</template>

        <Select v-model="language" not-found-text="No match" :placeholder="$t('license.form.placeholder.country')">
          <Option value="all">{{$t('manage.resources.allLanguages')}}</Option>
          <Option value="en">English</Option>
          <!-- <Option value="no">Norwegian</Option> -->
          <!-- <Option value="fr">French</Option>
          <Option value="sw">Swahili</Option> -->
        </Select>

        <Row :gutter="8">
          <i-Col class="card-container" :xs="12" :sm="12" :md="8" v-for="file in langFiles" :key="file.name">
            <Card>
              <a :href="`${publicPath}files/${file.name}.${file.ext}`" :download="`${file.name}.${file.ext}`" class="file">
                <img :src="require(`@/assets/thumbs/${file.name}.png`)">
                <h3>{{file.title}}</h3>
              </a>
            </Card>
          </i-Col>
        </Row>
      </Card>
      <Card class="video-card" name="1" id="1">
        <youtube video-id="3ci5VXVPi2g"></youtube>
        <div class="title">Black Box Building Example</div>
        <a :href="`${publicPath}files/black-box-building-example.mp4`" download="black-box-building-example.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} (54 MB)</Button>
        </a>
        <a :href="`${publicPath}files/black-box-building-example-small.mp4`" download="black-box-building-example-small.mp4" style="margin-left: 15px;">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} (9.3 MB)</Button>
        </a>
      </Card>
      <Card class="video-card" name="2" id="2">
        <youtube video-id="tJgIw0--ZQI"></youtube>
        <div class="title">How to fold the white boxes</div>
        <a :href="`${publicPath}files/how-to-fold-white-boxes.mp4`" download="how-to-fold-white-boxes.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} (131 MB)</Button>
        </a>
        <a :href="`${publicPath}files/how-to-fold-white-boxes-small.mp4`" download="how-to-fold-white-boxes-small.mp4" style="margin-left: 15px;">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} (20 MB)</Button>
        </a>
      </Card>
  </Content>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      language: "all",
      files: [
        {name: 'Literacy Lab Station Overview', ext: 'pdf', title: 'Literacy Lab Station Overview', lang: 'all'},
        {name: 'Numeracy Lab Station Overview', ext: 'pdf', title: 'Numeracy Lab Station Overview', lang: 'all'},
      ]
    }
  },
  computed: {
    langFiles() {
      return this.files.filter(f => this.language === null || this.language === "all" || ["all", this.language].includes(f.lang));
    }
  }
}
</script>

<style scoped lang="scss">
.main-content {
  text-align: center;

  @media only screen and (max-width: 767px) {
    .card-container:nth-child(2n+1) {
      clear: left;
    }
  }
  @media only screen and (min-width: 768px) {
    .card-container:nth-child(3n+1) {
      clear: left;
    }
  }

  .ivu-card {
    margin: 40px auto;

    @include respond-to(phone) {
      h3 {
        font-size: 16px !important;
      }
    }
    @include respond-to(tablet) {
      h3 {
        font-size: 17px !important;
      }
    }

    .file {
      cursor: pointer;

      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  ul {
    list-style: none;

    li {
      line-height: 24px !important;
    }
  }
}
</style>

<style lang="scss">
.main-content {
  .ivu-collapse {
    margin: 40px auto;

    &.collapse-air {
      background: transparent;
      border: none;

      > .ivu-collapse-item {
        margin: 15px auto;
      }
    }

    > .ivu-collapse-item {
      border-top: none;
    }
  }
}
</style>